import { MediaContentShowcaseItem } from "onnit-ui/lib/module/MediaContentShowcase";

const greensBlend: MediaContentShowcaseItem[] = [
    {
        image: `kale-cutout.png`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Organic Kale",
        summary:
            "A Cruciferous vegetable and member of the cabbage family, kale is one of the most nutrient-dense food ingredients on the planet.",
        detail:
            'Kale has antioxidant properties–which may help the body combat free radicals.<span class="oui-sup">&dagger;</span>'
    },
    {
        image: `brocoli-cutout.png`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Organic Broccoli",
        summary:
            "Another cruciferous vegetable and superfood.",
        detail:
            'Broccoli’s nutrition supports overall health and wellness.<span class="oui-sup">&dagger;</span>'
    },
    {
        image: `Spirulina-cutout.png`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Organic Spirulina",
        summary:
            "A non-toxic colored algae that grows in freshwater, spirulina has been consumed for centuries, going back to the Aztec Native Americans.",
        detail:
            "Spirulina is a nutritional powerhouse containing trace amounts of many bionutrients."
    }
];

export default greensBlend;
